/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneRow from 'base/components/standalone/Row';

export const DynamicStandaloneRow = StandaloneRow;
export type DynamicStandaloneRowProps = PropsFromComponent<typeof StandaloneRow>;

export const DynamicStandaloneRowWith = (extras: DynamicStandaloneExtras): typeof StandaloneRow => {
    return function DynamicStandaloneRow(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Row');
        return <StandaloneRow {...mergeProps({ options: { theme } }, props)} />;
    }
}